import styled from 'styled-components';

export const DelButton = styled.div`
    background-color: #498205;
    color: white;
    font-weight: bold;
    width: 120px;
    padding: 3px 15px;
    border-radius: 15px;
    position: relative;
`;

export const DialogMessage = styled.div`
padding-left: 10px;
`;
